export const CSAT_SCORES = ['bad', 'poor', 'average', 'good', 'excellent'];
/** Numeric mapping for averages (spec §5.12): bad=1 .. excellent=5. */
export const CSAT_VALUE = {
    bad: 1,
    poor: 2,
    average: 3,
    good: 4,
    excellent: 5,
};
export function csatToNumber(score) {
    return CSAT_VALUE[score];
}
/** Average of the given scores, null when empty. Rounded to 2 decimals. */
export function csatAverage(scores) {
    if (scores.length === 0)
        return null;
    const sum = scores.reduce((acc, s) => acc + CSAT_VALUE[s], 0);
    return Math.round((sum / scores.length) * 100) / 100;
}
//# sourceMappingURL=csat.js.map